import { Box, Container, Paper, Typography } from "@mui/material";

export default function PartInstruction({ currentPart, partStyle }) {
  const preText = {
    1: {
      title: "LISTENING",
      text: "In the Listening test, you will be asked to demonstrate how well you understand spoken English. The entire Listening test will last approximately 45 minutes. There are four parts, and directions are given for each part. You must mark your answers on the separate answer sheet. Do not write your answers in your test book."
    }, 
    5: {
      title: "READING",
      text: "In the Reading test, you will read a variety of texts and answer several different types of reading comprehension questions. The entire Reading test will last 75 minutes. There are three parts, and directions are given for each part. You are encouraged to answer as many questions as possible within the time allowed.\n You must mark your answers on the separate sheet. Do not write your answers in your test book." 
    }
  }
  return (
    <Container maxWidth="xl">
      <Paper
        elevation={3}
        sx={{ p: 4, borderRadius: 2, mt: 3, textAlign: "center", ...partStyle }}
      >
        {!!preText[currentPart?.partNumber] && (
          <Box sx={{ mb: 2 }}>
            <Typography
              variant="h5"
              component="h1"
              sx={{ mb: 2, fontWeight: 600 }}
            >
              {preText[currentPart.partNumber].title}
            </Typography>
            {/* <Typography
              variant="body1"
              paragraph
            >
            </Typography> */}

            <Paper
              variant="outlined"
              sx={{
                p: 3,
                borderRadius: 2,
                textAlign: "left",
                mb: 4,
                bgcolor: "background.paper",
                borderColor: "primary.light",
              }}
            >
              <Typography variant="body1" paragraph>
                {preText[currentPart.partNumber].text}
              </Typography>
            </Paper>
          </Box>
        )}
        <Typography variant="h5" component="h1" sx={{ mb: 2, fontWeight: 600 }}>
          Part {currentPart.partNumber}
        </Typography>

        {currentPart.instructions && (
          <Paper
            variant="outlined"
            sx={{
              p: 3,
              borderRadius: 2,
              textAlign: "left",
              mb: 4,
              bgcolor: "background.paper",
              borderColor: "primary.light",
            }}
          >
            <Typography variant="body1" paragraph>
              <strong>Directions: </strong>
              {currentPart.instructions}
            </Typography>
          </Paper>
        )}

        {currentPart.imageUrl && (
          <Box
            sx={{
              my: 4,
              maxWidth: "100%",
              height: "auto",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <img
              src={currentPart.imageUrl}
              alt="Part instructions"
              style={{
                maxWidth: "100%",
                height: "auto",
                maxHeight: "400px",
                objectFit: "contain",
                objectPosition: "center",
              }}
            />
          </Box>
        )}
      </Paper>
    </Container>
  );
}
